import _ from 'lodash';

const paymentMethodTypeToBookingChannelPaymentMethodType = {
  creditCard: 'creditCard',
  businessAccount: 'businessAccount',
};

export class AllowedPaymentMethodDelegate {
  static isCreditCardPaymentMethodAllowed({ allowedPaymentMethods }) {
    return allowedPaymentMethods.some(paymentMethod => paymentMethod.type === 'creditCard');
  }

  static resolveAllowedPaymentMethods({ allowedPaymentMethods, paymentMethods }) {
    const allowedPaymentMethodTypes = allowedPaymentMethods.map(paymentMethod => paymentMethod.type);

    const paymentMethodsToReturn = paymentMethods.map(paymentMethod => {
      if (allowedPaymentMethodTypes.includes(paymentMethodTypeToBookingChannelPaymentMethodType[paymentMethod.type])) {
        return paymentMethod;
      }
    })

    if (allowedPaymentMethodTypes.includes('cash')) { paymentMethodsToReturn.unshift({ type: 'cash', title: 'cash', brand: 'cash', paymentMethodType: 'cash', defaultPayment: false, },); }
    return this.payemntMethodsFactory(_.compact(paymentMethodsToReturn));
  }

  static payemntMethodsFactory(paymentMethods) {
    return paymentMethods
    .filter(paymentMethod => paymentMethod.type)
    .map(paymentMethod => ({
      ...paymentMethod,
    }));
  }
}
